import { styled } from "@grupoboticario/flora-react"; 

export const MenuTop = styled("div", {
  display: "flex",
  flexDirection: "row",
  alignContent: "center",
  alignItems: "center",
  width: "100%",
  height: "60px",
  background: "#364372",
  justifyContent: "flex-start",
  gap:"$5"
});
 
export const MenuItems = styled("div",  {
  display: "none",
  "@desktop": {
    display: "flex",
    "button": {
      padding: "0.5rem"
    }
  },
  
})

export const MenuLeft = styled("div",  {
  paddingLeft: "10px",
  display: "flex",
  gap:"$5",
  alignContent: "center",
  alignItems: "center",
})

export const MenuRight = styled("div",  {
  display: "flex",
  gap:"$5",
  flex: "1",
  justifyContent: "flex-end",
  "@desktop": { 
    gap:"$2",
  },
  '@fullscreen': {
    gap:"$12",
  }
})